/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { webhookEndpointsCreate } from "../../funcs/webhookEndpointsCreate.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.CreateWebhookEndpointPayload$inboundSchema,
};

export const tool$webhookEndpointsCreate: ToolDefinition<typeof args> = {
  name: "webhook-endpoints-create",
  description: `Create Webhook Endpoint

Create a webhook endpoint to receive notifications about document status updates, connection sync progress, partition limits, and other tenant events.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await webhookEndpointsCreate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
